export function addPicture(picture) {
  return {
    type: 'ADD_PICTURE',
    payload: { picture },
  }
}

export function removePicture(uid) {
  return {
    type: 'REMOVE_PICTURE',
    payload: { uid },
  }
}
